import React from 'react';
import { XMarkIcon, CheckCircleIcon, StarIcon, ShieldCheckIcon } from '@heroicons/react/24/solid';

const PaywallModal = ({ isOpen, onClose, onUpgrade }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/80 backdrop-blur-sm transition-opacity animate-in fade-in duration-200">
      
      {/* MODAL CARD */}
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden relative transform transition-all scale-100">
        
        {/* CLOSE BUTTON */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors z-10"
        >
          <XMarkIcon className="h-6 w-6" />
        </button>

        {/* HEADER: THE "HOOK" */}
        <div className="bg-gradient-to-br from-slate-900 to-slate-800 p-8 text-center relative overflow-hidden">
          {/* Decorative Shine */}
          <div className="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl"></div>
          
          <div className="relative z-10">
            <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg shadow-yellow-500/20 text-white">
              <StarIcon className="h-6 w-6" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">Unlock Unlimited Growth</h2>
            <p className="text-slate-400 text-sm">
              You've hit the 2-client limit on the Free plan. <br/>
              Ready to scale your practice?
            </p>
          </div>
        </div>

        {/* BODY: THE "VALUE STACK" */}
        <div className="p-8">
          <div className="space-y-4 mb-8">
            <FeatureItem text="Unlimited Active Clients" />
            <FeatureItem text="Automated Deadline Reminders" />
            <FeatureItem text="10GB Secure Document Storage" />
            <FeatureItem text="Priority Concierge Support" />
          </div>

          {/* PRICING ANCHOR */}
          <div className="flex items-end justify-center gap-2 mb-8">
            <span className="text-4xl font-extrabold text-slate-900">$29</span>
            <span className="text-slate-500 font-medium mb-1">/ month</span>
          </div>

          {/* CTA BUTTON */}
          <button 
            onClick={onUpgrade} 
            className="w-full bg-brand-600 hover:bg-brand-700 text-white py-4 rounded-xl font-bold text-lg shadow-xl shadow-brand-200 transition-all transform hover:-translate-y-1 active:scale-95 flex items-center justify-center gap-2"
          >
            Upgrade to Premium
          </button>

          {/* RISK REVERSAL (The "Safety Net") */}
          <div className="mt-4 text-center">
            <p className="text-xs text-slate-400 flex items-center justify-center gap-1.5">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-500" />
              30-Day Money-Back Guarantee. Cancel anytime.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Helper Component for List Items
const FeatureItem = ({ text }) => (
  <div className="flex items-center gap-3">
    <div className="shrink-0 w-5 h-5 rounded-full bg-emerald-100 flex items-center justify-center">
      <CheckCircleIcon className="h-3.5 w-3.5 text-emerald-600" />
    </div>
    <span className="text-slate-700 font-medium text-sm">{text}</span>
  </div>
);

export default PaywallModal;
